export interface TronTransactionReceipt {
    txid: string;
}
